__turbopack_context__.v({
  "adBanner": "N9dVxq_adBanner",
  "adBannerContainer": "N9dVxq_adBannerContainer",
  "hideMobile": "N9dVxq_hideMobile",
  "image": "N9dVxq_image",
  "size-160x600": "N9dVxq_size-160x600",
  "size-200x200": "N9dVxq_size-200x200",
  "size-350x50": "N9dVxq_size-350x50",
  "size-970x90": "N9dVxq_size-970x90",
  "slideInAnimation": "N9dVxq_slideInAnimation",
});
